import React, { useEffect, useState } from "react";
import { getData } from "../api/AuthenticatedApiCaller";
import { TraitsApi } from "../api/AdminApi";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function VehicleTraitSelect({type,traits,changeTrait,currentTraitId}) {

  const [id,setId] = useState(currentTraitId)


    return (

      <FormControl>
        <InputLabel >{type}</InputLabel>
        <Select
        sx={{mt:0.5}}
        value={id !== undefined ? id : ""}
        onChange={(event)=>{
          changeTrait(event.target.value)
          setId(event.target.value)
        }}
        >
         {traits.map((trait) =>(
            <MenuItem value={trait.id}>{trait.text}</MenuItem>
         ))}
        </Select>
      </FormControl>
    );
}
